module.exports = __webpack_public_path__ + "static/media/exclamation.de8fede9.png";